<div class="card-body card-body-filter batchcontainer">
  <div class="batch-toolbar">
    <button type="button" class="batch-action" (click)="openAssigmentModal()">
      <i class="fas fa-user" aria-hidden="true"></i>
      <span>Asignar</span>
    </button>
    <button type="button" class="batch-action" (click)="return()">
      <i class="fas fa-undo" aria-hidden="true"></i>
      <span>Devolver</span>
    </button>
    <button type="button" class="batch-action" (click)="openChangeRequesterDialog()">
      <i class="fas fa-user-edit" aria-hidden="true"></i>
      <span>Cambiar solicitante</span>
    </button>
    <button type="button" class="batch-action" (click)="changestatus()">
      <i class="fas fa-sitemap" aria-hidden="true"></i>
      <span>Cambiar estado</span>
    </button>
    <button type="button" class="batch-action" (click)="setCollaborator()">
      <i class="fas fa-users" aria-hidden="true"></i>
      <span>Agregar colaborador</span>
    </button>
    <div class="dropdown batch-more" (mouseenter)="openMainMenu()" (mouseleave)="closeMainMenu()">
      <button type="button" class="batch-action dropdown-toggle" id="masMenu"
        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Más
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="masMenu">
        <button class="dropdown-item" type="button" (click)="deleteRequirements()">Eliminar requerimientos</button>
        <button *ngIf="false && showScrapingToggle" class="dropdown-item" type="button" (click)="openScrapingToggle(true)">Activar seguimiento</button>
        <button *ngIf="false && showScrapingToggle" class="dropdown-item" type="button" (click)="openScrapingToggle(false)">Desactivar seguimiento</button>
      </div>
    </div>
  </div>
</div>
